import React from 'react';
import PricingCard from './PricingCard';

function PricingPreview() {
  return (
    <section className="section" id="pricing" style={{paddingTop: 40}}>
      <div className="center-heading">
        <span className="kicker">Simple pricing</span>
        <h2>Three packages.<br /><em>Or just the one thing you need.</em></h2>
      </div>
      <PricingCard />
      <p className="service-note"><a className="footer-link" href="#/pricing">See how pricing works and common questions</a></p>
    </section>
  );
}

export default PricingPreview;
